import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface OnboardingState {
  onboardingDone: boolean;
  markDone: () => void;
  /**
   * setFromServer: server-authoritative suppression on cross-device login.
   * If the server says done=true, set locally true.
   * If the server says done=false, do NOT regress a locally-true flag
   * (CONTEXT: logout does NOT clear local onboarding_done; local takes precedence
   * over server false to prevent re-appearance after stale server sync).
   */
  setFromServer: (done: boolean) => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      onboardingDone: false,
      markDone: () => set({ onboardingDone: true }),
      setFromServer: (done) => {
        if (done) {
          set({ onboardingDone: true });
        }
        // If done=false, do NOT un-set a locally-true flag (cross-device suppression)
      },
    }),
    {
      name: 'estimatix-onboarding',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      // All state is persisted — no partialize exclusions needed for this store
    },
  ),
);
